import { get, post } from '@/utils/http'
import store from 'store';

// 用户关联租户列表（登录选择）
export const userTenantLogin = async (data = {}) => {
  const res = await post('/passport/user/unify/login', {
    ...data,
    client_id: process.env.REACT_APP_CLIENT_ID,
  });
  const { token = {} } = res;
  store.set('token', token.access_token);
  window.localStorage.setItem('loginType', JSON.stringify({
    type: data.grantType,
    isAlert: false,
  }));
  return {
    ...res,
    ...token,
  };
};

// 获取租户列表
export const userTenantList = async (data = {}) =>
  get('/passport/user/tenant/list', data);

// 切换租户
export const userSwitchTenant = async (data = {}) => get('/passport/user/switchTenant', data);

// 内网查询
// export const checkIntranet = async (data = {}) => get('/passport/intranet', data);
export const checkIntranet = () => {
  return new Promise((resolve, reject) => {
    const body = document.getElementsByTagName('body')[0];
    // 动态添加script标签
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '//approve-login.ruigushop.com/isIntranet.js?_t=' + Math.random() * 1e18;
    body.appendChild(script);
    script.onload = () => {
      body.removeChild(script);
      resolve(true)
    };
    script.onerror = () => {
      body.removeChild(script);
      resolve(false)
    };
  });
}
